// Firebase Configuration
const firebaseConfig = {
    apiKey: "AIzaSyCAkWy0fVjvBw-zFk9sno-wZqCux2fKO8Q",
    authDomain: "royal-tour-14c3e.firebaseapp.com",
    projectId: "royal-tour-14c3e",
    storageBucket: "royal-tour-14c3e.appspot.com",
    messagingSenderId: "1081044263000",
    appId: "1:1081044263000:web:c571d0e1347d96961cea2d"
  };

export default firebaseConfig;